import React from "react";
import { Ticket } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

// Winning ticket announcement banner. Renders only when enabled in
// Admin → Site Settings. Fully editable (header, body, ticket number) from there.
export const WinningTicketBanner = () => {
    const { settings } = useSettings();
    if (!settings?.ticket_banner_enabled) return null;

    return (
        <section className="bg-[#C4522A] border-b-4 border-[#C9A84C] px-4 py-8" data-testid="winning-ticket-banner">
            <div className="max-w-4xl mx-auto text-center">
                <div className="flex items-center justify-center gap-2 mb-2">
                    <Ticket size={20} className="text-[#F5EDD6]" />
                    <span className="font-marker text-[#F5EDD6] text-xl">{settings.ticket_header}</span>
                </div>
                <p className="font-manrope text-[#F5EDD6]/90 text-base sm:text-lg max-w-2xl mx-auto mb-3">
                    {settings.ticket_body}
                </p>
                <div className="inline-block bg-[#3D2008] text-[#C9A84C] font-anton uppercase tracking-wider text-2xl sm:text-3xl px-8 py-3 border-2 border-[#C9A84C]" data-testid="winning-ticket-number">
                    Ticket #: {settings.ticket_number}
                </div>
            </div>
        </section>
    );
};

export default WinningTicketBanner;
